module.exports = __webpack_public_path__ + "static/media/services.332b42a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/services.jpg
// module id = 235
// module chunks = 0